/* @flow strict */

/* eslint-disable react/jsx-handler-names */
/* eslint-disable camelcase */

import * as React from 'react';
import { withRouter } from 'react-router-dom';
import Modal from '/client/src/components/Modal';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import BtnLoader from '/client/src/components/btns/circularProgress/';
import EmailNumber from './forms/emailNumber';
import Organization from './forms/organization';
import Links from './forms/links';
import Stripe from './forms/stripe';
import { PUT } from '/client/src/api';
import { timeerOffModal } from '/client/src/constants/';
import { validateInput } from '/client/src/utils/validateInput';
import { emailRegexp } from '/client/src/constants/';

import './styles.scss';
import { GetErrorValidation } from '../../../utils/errorMessageValidation';

type PropsType = {
  handleToggleWellcomeModal: (boolean) => void
};

type StatePropsType = {
  form: number,
  email: string,
  tel: string,
  billRemark: string,
  companyName: string,
  website: string,
  stripe: string,
  isLocked: boolean
};

class WellcomeModal extends React.Component<PropsType, StatePropsType> {
  props: PropsType;
  state: StatePropsType;

  static contextType = DefaultContainerContext;

  constructor(props: PropsType, context: {}) {
    super(props);

    const search = _.get(props, 'location.search', '');
    const isOnlyStripe = search && search.includes('token');

    this.state = {
      form: isOnlyStripe ? 2 : 0,
      isOnlyStripe,
      email: _.get(context, 'profileCurrent.email', ''),
      tel: _.get(context, 'profileCurrent.phone_number', ''),
      billRemark:  _.get(context, 'profileCurrent.organization_info.bill_remark', ''),
      companyName: _.get(context, 'profileCurrent.company_name', ''),
      website: _.get(context, 'profileCurrent.website', ''),
      stripe: '',
      isLocked: false
    };
  }

  handleClose = (): any => {
    const { handleToggleWellcomeModal } = this.props;

    handleToggleWellcomeModal(false);
  };

  handleFinish = async () => {
    const data = {
      bill_remark: this.state.billRemark,
      company_name: this.state.companyName,
      contact_email: this.state.email,
      phone_number: this.state.tel,
      website: this.state.website,
      show_welcome: false
    };

    this.handleClose();
    await PUT('/api/v1/1/merchants/organization_info_app', data);
    window.localStorage.removeItem('isFirstSignIn');
    this.props.history.push('?');
  }

  handleSaveWithoutStripe = async (setStatus: (string) => void) => {
    const {
      companyName,
      billRemark,
      email,
      website,
      tel,
      isLocked
    } = this.state;

    if (isLocked) {
      return;
    }

    this.setState({
      isLocked: true
    }, () => {
      setStatus('loading');
    });


    const data = {
      bill_remark: billRemark,
      company_name: companyName,
      contact_email: email,
      phone_number: tel,
      website,
      show_welcome: true
    };

    try {
      const { success } = await PUT('/api/v1/1/merchants/organization_info_app', data);

      if (success) {
        this.setState({
          isLocked: false
        }, () => {
          setStatus('success');
          this.context.handleGetProfile();
          this.context.handleShowSystemDialog(true, {
            systemDialogType: 'success',
            systemDialogTitle: 'Great!',
            systemDialogContent: 'Successfully saved'
          });

          this.handleChangeForm('next');
        });
      }
    } catch (error) {
      this.setState({
        isLocked: false
      }, () => {
        this.context.handleShowSystemDialog(true, {
          systemDialogType: 'error',
          systemDialogTitle: 'Error!',
          systemDialogContent: <GetErrorValidation data={error.data} />
        });

        setStatus('error');
        console.error(error);

        setTimeout(() => {
          setStatus('');
        }, timeerOffModal * 2);
      });
    }
  }

  handleChangeForm = (direction: string) => {
    const { email } = this.state;
    const currentForm = this.state.form;

    let nextForm = this.state.form;

    if (currentForm === 0) {
      const isValidEmailByRegex = _.size(email) ? emailRegexp.test(email) : false;

      if (!isValidEmailByRegex) {
        // Trigger to mark invalide field
        validateInput(document.getElementById('email').parentNode, null);
      }

      if (_.size(email) && !isValidEmailByRegex) {
        return;
      }
    }

    if (direction === 'next') {
      if (currentForm < 3) {
        nextForm = currentForm + 1;
      } else {
        nextForm = currentForm;
      }
    } else if (currentForm > 0) {
      nextForm = currentForm - 1;
    } else {
      nextForm = 0;
    }

    this.setState({
      form: nextForm
    });
  }

  handleChangeInput = (e: SyntheticEvent<HTMLInputElement>) => {
    const name = e.target.id;
    const value = e.target.value;

    this.setState({
      [name]: value
    });
  };

  render(): React.Element<'div'> {
    const {
      isLocked,
      form,
      email,
      tel,
      billRemark,
      companyName,
      website
    } = this.state;

    return (
      <Modal
        opened
        ignoreOutsideClick
        altView
        fullScreen
      >
        <div className="modal-dialog customModal WellcomeModal" role="document">
          <div className="modal-content">
            <div className="modal-custom-header">
            <div className="form-logo">
              <span className="sparxo-logo1-text" />
            </div>
            </div>
            <div className="modal-sub-header">
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              onClick={this.handleFinish}
            >
              <span aria-hidden="true">×</span>
              <span className="sr-only">Close</span>
            </button>
            </div>
            <div className="modal-body" style={{ cursor: isLocked ? 'not-allowed' : 'auto' }}>
              {+form === 0 ?
                <EmailNumber
                  email={email}
                  tel={tel}
                  handleChangeInput={this.handleChangeInput}
                /> : null
              }

              {+form === 1 ?
                <Organization
                  billRemark={billRemark}
                  companyName={companyName}
                  website={website}
                  handleChangeInput={this.handleChangeInput}
                /> : null
              }

              {+form === 2 ?
                <div className='stripe-container'>
                <Stripe
                  handleChangeInput={this.handleChangeInput}
                />
                </div>
                : null
              }
              {+form === 3 ?
                <Links
                  handleClose={this.handleFinish}
                /> : null
              }
            </div>
          </div>

          <div className="modal-footer">
            <div className='modal-footer_container'>
            {(+form !== 0 && !this.state.isOnlyStripe) &&
              <button
                data-type='outline-with-border'
                className="btn btn-gray"
                style={{
                  float: 'left'
                }}
                onClick={() => {
                  this.handleChangeForm('prev');
                }}
              >Back</button>
            }
            {+form === 2 &&
              <button
                data-type='outline'
                className="btn btn-gray"
                onClick={this.handleFinish}
              >Skip</button>
            }

            {+form !== 1 ?
              <button
                className="btn btn-pink"
                onClick={() => {
                  if (+form === 3) {
                    this.handleFinish();
                  } else {
                    this.handleChangeForm('next');
                  }
                }}
              >{
                +form === 3 ? 'Close' : 'Next'
              }</button> :

              <span className="custom-pb-container">
                <BtnLoader
                  label='Next'
                  handleCallBack={(e: SyntheticEvent<HTMLButtonElement>, setStatus: (string) => void) => {
                    this.handleSaveWithoutStripe(setStatus);
                  }}
                />
              </span>
            }
          </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default withRouter(WellcomeModal);
